var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWarden(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 1707 1707",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    fillRule: "evenodd",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M853 865c-158 0-289-91-333-229-30-4-53-30-53-61v-56c0-26 15-48 37-57v-59c0-17 14-30 30-30h638c17 0 30 13 30 30v59c22 9 38 31 38 57v56c0 31-24 57-54 61-43 138-174 229-333 229zM543 576c14 0 26 9 29 23 30 123 143 206 281 206 139 0 252-83 281-206 4-14 17-24 32-23h12c1 0 2 0 2-1v-56c0-1-1-2-2-2h-6c-16 0-30-13-30-30v-54H564v54c0 17-13 30-30 30h-6s-1 1-1 2v56c0 1 1 1 1 1h13z",
    opacity: 1,
    "data-original": "#3e3b3e",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M1172 433H534c-9 0-17-4-23-11-5-7-8-16-6-25l48-243c2-10 8-18 17-22L840 3c8-4 17-4 26 0l271 129c8 4 15 12 16 22l49 243c1 9-1 18-7 25-5 7-14 11-23 11zm-601-60h565l-38-193L853 63 609 180z",
    opacity: 1,
    "data-original": "#ee9c15",
    className: ""
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#3e3b3e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1516 1706H191c-17 0-30-13-30-30v-358c0-214 174-388 388-388h96c16 0 30 14 30 30 0 17-14 30-30 30h-96c-181 0-328 147-328 328v328h1265v-328c0-181-147-328-328-328h-96c-16 0-30-13-30-30 0-16 14-30 30-30h96c214 0 388 174 388 388v358c0 17-13 30-30 30z",
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#3e3b3e",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429 1706c-17 0-30-13-30-30v-216c0-16 13-30 30-30 16 0 30 14 30 30v216c0 17-14 30-30 30zM1278 1706c-16 0-30-13-30-30v-216c0-16 14-30 30-30 17 0 30 14 30 30v216c0 17-13 30-30 30zM853 1165c-7 0-14-3-19-7L625 983c-12-10-14-29-3-42 10-13 29-14 42-4l189 159 190-159c13-10 32-9 42 4 11 13 9 32-4 42l-209 175c-5 4-12 7-19 7z",
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#3e3b3e",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M645 990c-3 0-6 0-8-1-16-4-26-21-21-37l44-165c4-16 21-26 37-21 16 4 25 20 21 36l-44 166c-4 13-16 22-29 22zM1062 990c-13 0-25-9-29-22l-44-166c-5-16 5-32 21-37 16-4 32 6 37 22l44 165c4 16-5 33-21 37-3 1-5 1-8 1z",
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#3e3b3e",
    className: ""
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M1630 1706c-17 0-30-13-30-30v-378c0-16 13-30 30-30s30 14 30 30v378c0 17-13 30-30 30zM77 1706c-17 0-30-13-30-30v-378c0-16 13-30 30-30 16 0 30 14 30 30v378c0 17-14 30-30 30zM1073 544H634c-9 0-17-4-23-10l-99-111c-8-9-10-22-5-32 5-11 16-18 27-18h638c12 0 23 7 28 18 4 10 2 23-5 32l-100 111c-5 6-13 10-22 10zm-426-60h413l45-51H602zM853 338c-58 0-106-47-106-106s48-106 106-106c59 0 107 47 107 106s-48 106-107 106zm0-152c-25 0-46 20-46 46s21 46 46 46c26 0 47-20 47-46s-21-46-47-46z",
    opacity: 1,
    "data-original": "#ee9c15",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M853 1381c-9 0-19-4-24-13-10-14-6-32 7-41l183-124-11-59c-2-10 1-20 8-27s17-10 27-8l76 13 41-45-117-93c-13-11-15-30-4-43 10-13 29-15 42-4l142 114c6 5 10 13 11 21 0 8-2 16-8 22l-73 81c-7 7-18 11-28 9l-50-9 6 36c3 12-2 24-12 30l-199 135c-5 4-11 5-17 5z",
    opacity: 1,
    "data-original": "#3e3b3e",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M853 1381c-5 0-11-1-16-5l-199-135c-10-6-15-18-13-30l7-36-50 9c-11 2-21-2-28-9l-73-81c-6-6-9-14-8-22s5-16 11-21l142-114c13-11 32-9 42 4s8 32-5 43l-116 93 40 45 77-13c10-2 20 1 26 8 7 7 10 17 9 27l-11 59 182 124c14 9 17 27 8 41-6 9-15 13-25 13z",
    opacity: 1,
    "data-original": "#3e3b3e",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M853 1706c-17 0-30-13-30-30v-541c0-17 13-30 30-30s30 13 30 30v541c0 17-13 30-30 30zM671 1422H543c-17 0-30-13-30-30s13-30 30-30h128c16 0 30 13 30 30s-14 30-30 30z",
    opacity: 1,
    "data-original": "#3e3b3e",
    className: ""
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarden);
export default __webpack_public_path__ + "static/media/warden.c2d29edbc0328373aa90a9e0c70be8ce.svg";
export { ForwardRef as ReactComponent };